<template>
  <v-tabs class="sub-menu md-3" slider-color="primary">
    <v-tab class="sub-menu-item" to="/settings/travel-service" exact>
      {{ $t("settings.travelService.menu.acceptance") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/travel-service/additional-parameters">
      {{ $t("settings.travelService.menu.additionalParameters") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/travel-service/mail-subject">
      {{ $t("settings.travelService.menu.mailSubject") }}
    </v-tab>
    <v-tab class="sub-menu-item" to="/settings/travel-service/additional-settings">
      {{ $t("settings.travelService.menu.additionalSettings") }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "TravelServiceMenu"
};
</script>

<style scoped></style>
